import React from 'react';
import DocumentsSection from '../../../sections/AdminDashboard/Configuration/Documents';

const Documents = () => {
  return <DocumentsSection />;
};

export default Documents;
